import { render, staticRenderFns } from "./ToBinLocation.vue?vue&type=template&id=79ef27df&"
import script from "./ToBinLocation.vue?vue&type=script&lang=js&"
export * from "./ToBinLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports